import React from 'react';
import Table from '../../../shared/table/index'
import InspectionTransform from '../../../../lib/utils/transforms/inspections'

const header = ['FECHA', 'POLIZA', 'CLIENTE', 'PLACA', 'MOTOR', 'CHASIS', 'ESTADO'];

const InspectionsBody = ({allInspections = [], openModalChangeToInspection = () => {}, isViewer}) => {

    return (
        <div className="bg-f3">
            <Table headerTitles={header}
                   data={allInspections}
                   transformFn={InspectionTransform.transformTable}
                   openModalChangeToInspection={openModalChangeToInspection}
                   isViewer={isViewer}/>
        </div>
    );
};

export default InspectionsBody;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspections/inspections-body.js